import {StyledListItem} from "@/shared/StyledComponents";
import React, {ReactElement} from "react";
import {LabelerTask} from "@/fyneai-shared/types";
import {TaskAltOutlined} from "@mui/icons-material";

export function LabelerTasksListView({tasks, selectedTask, setSelectedTask}: {
  tasks: LabelerTask[],
  selectedTask: LabelerTask,
  setSelectedTask: (task: LabelerTask) => void
}): ReactElement {
  return <>
    {tasks.map((task) => <StyledListItem
      onClick={() => setSelectedTask(task)}
      selected={task === selectedTask}
      key={task.id}
      icon={TaskAltOutlined}
      title={task.name}
    />)}
  </>;
}
